import { useaxios } from "../../../utils/useaxios";
export default (from, to, service_id) => recaller => setrecaller => initDispatch => clear => settype => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    // initDispatch({ type: 'loadingTrue' });
    useaxios('report/servicereport.php', { from, to, service_id }).then((res) => {
        if (res == "auth_failed") {
            alert('no internet connection');
            return false;
        }
        if (res.status == "ok") {
            initDispatch({ type: 'setservicereport', payload: { total_service_report_price: res.service_price, total_service_report_qty: res.service_qty } });
            settype('servicereport');
            // setrecaller(recaller + 1);
        } else {
            // clear();
        }
        // setloading(false);
    });
}